import history from '../../util/history'

const toApiMessageView = (basePath, reservationId) => {
  history.replace(`${basePath}/${reservationId}/api_message`)

  return true
}

export default toApiMessageView
